import { useCallback } from 'react';
import { FETCH_MODEL_PORTFOLIOS } from '../queries';
import {
  buildFetchModelPortfoliosSearchVariables,
  mapModelPortfolioSearchHits,
} from '../utils/modelSearchOptions';
import { TOOLBAR_SEARCH_MIN_CHARS } from '../utils/portfolioSearchOptions';
import { useLazySearchOptions } from './useLazySearchOptions';

export function useModelViewSearchOptions({
  organizationId,
}: {
  organizationId?: string;
}) {
  const buildVariables = useCallback(
    (trimmed: string) =>
      buildFetchModelPortfoliosSearchVariables(
        organizationId as string,
        trimmed,
      ),
    [organizationId],
  );

  const mapResults = useCallback(
    (
      data:
        | { fetchModelPortfolios?: { modelPortfolios?: unknown } }
        | undefined,
    ) =>
      mapModelPortfolioSearchHits(
        data?.fetchModelPortfolios?.modelPortfolios as Parameters<
          typeof mapModelPortfolioSearchHits
        >[0],
      ).map((model) => ({
        id: model.id,
        label: model.name,
        searchValue: model.name,
      })),
    [],
  );

  return useLazySearchOptions({
    query: FETCH_MODEL_PORTFOLIOS,
    minChars: TOOLBAR_SEARCH_MIN_CHARS,
    isEnabled: Boolean(organizationId),
    buildVariables,
    mapResults,
    errorMessageKey: 'filters.modelSearchFailed',
  });
}
